import { createSlice } from "@reduxjs/toolkit";

import type { TLitheSliceState } from "../../types/lithe.type";

import { extractQuestionsLithe } from "../../utils/litheUtils";

import {
	fetchLitheThunk,
	fetchLitheSpecsQuestionsThunk,
	fetchLitheApprovalInfo,
} from "./lithe.thunk";

const initialState: TLitheSliceState = {
	meta: { data: null, loading: false, error: null },
	specsQuestions: {
		data: null,
		loading: false,
		error: null,
	},
	approvalInfo: { data: null, loading: false, error: null },
};
const litheSlice = createSlice({
	name: "lithe",
	initialState,
	reducers: { resetLitheState: () => initialState },
	extraReducers: (builder) => {
		builder
			.addCase(fetchLitheThunk.pending, (state) => {
				state.meta.loading = true;
				state.meta.error = null;
			})
			.addCase(
				fetchLitheThunk.fulfilled,
				(state, action) => {
					const data = action.payload;
					state.meta = {
						loading: false,
						error: null,
						data: {
							litheId: data.lithe_id,
							litheName: data.lithe_name,
							assetClassId: "",
							litheCreationType: data.lithe_type,
							litheScope: data.lithe_scope,
							datasetId: data.dataset_id ?? null,
							datasetName: data.dataset_name ?? null,
							allSteps: data.all_steps,
							currentStep: data.current_step,
							quickStart: data.quick_start ?? {},
						},
					};
				}
			)
			.addCase(
				fetchLitheThunk.rejected,
				(state, action) => {
					state.meta.loading = false;
					state.meta.error = action.payload;
				}
			);
		builder
			.addCase(
				fetchLitheSpecsQuestionsThunk.pending,
				(state) => {
					state.specsQuestions.loading = true;
					state.specsQuestions.error = null;
				}
			)
			.addCase(
				fetchLitheSpecsQuestionsThunk.fulfilled,
				(state, action) => {
					state.specsQuestions = {
						data: extractQuestionsLithe(action.payload),
						loading: false,
						error: null,
					};
				}
			)
			.addCase(
				fetchLitheSpecsQuestionsThunk.rejected,
				(state, action) => {
					state.specsQuestions.loading = false;
					state.specsQuestions.error = action.payload;
				}
			);
		builder
			.addCase(fetchLitheApprovalInfo.pending, (state) => {
				state.approvalInfo.loading = true;
				state.approvalInfo.error = null;
			})
			.addCase(
				fetchLitheApprovalInfo.fulfilled,
				(state, action) => {
					state.approvalInfo = {
						data: action.payload,
						loading: false,
						error: null,
					};
				}
			)
			.addCase(
				fetchLitheApprovalInfo.rejected,
				(state, action) => {
					state.approvalInfo.loading = false;
					state.approvalInfo.error = action.payload;
				}
			);
	},
});
export const LitheSliceActions = litheSlice.actions;
export const LitheReducer = litheSlice.reducer;
